import CRMSelect from './CRMSelect';

export default CRMSelect;
